import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页', icon: 'ri-home-line' },
    { to: '/category/josei-romance', label: '分类浏览', icon: 'ri-grid-line' },
    { to: '/about', label: '关于我们', icon: 'ri-information-line' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-200))]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500/20">
              <i className="ri-book-open-line text-accent-500 text-lg"></i>
            </span>
            <span className="text-lg font-bold font-heading text-foreground-950 whitespace-nowrap">
              漫画导航
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-md text-sm transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'bg-accent-500/15 text-accent-500'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <span className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs text-accent-500 whitespace-nowrap">
              <i className="ri-shield-check-line"></i>
              18+ 内容声明
            </span>
            <button
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50 transition-colors"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                  location.pathname === link.to
                    ? 'bg-accent-500/15 text-accent-500'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50'
                }`}
              >
                <i className={`${link.icon} text-base`}></i>
                {link.label}
              </Link>
            ))}
            <div className="pt-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs text-accent-500">
                <i className="ri-shield-check-line"></i>
                18+ 内容声明
              </span>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}